import React, {useEffect, useState, useContext} from 'react';
import axios from 'axios';
import API_BASE_URL from '../../utils/apiBaseUrl';
import {Card, Nav, Button, CardGroup, Dropdown, DropdownButton } from 'react-bootstrap';
import './Breakdown.css';
import { AccountContext } from '../../components/UserPool/Account';
import GetTargetDate from '../../utils/GetTargetDate';
import teamIcons from '../../utils/teamIcons';
import AlertModal from '../../components/AlertModal/AlertModal';
import { teams } from '../../utils/teamList';

function Breakdown({year}) {
    const { getSession } = useContext(AccountContext);
    const [newSession, setNewSession] = useState(undefined);
    const [selectedPicksBreakdown, setSelectedPicksBreakdown] = useState({});
    const [unselectedPicksBreakdown, setUnselectedPicksBreakdown] = useState({});
    const [showCurrWeekAlertModal, setShowCurrWeekAlertModal] = useState([false, '', ''])
    const [teamBreakdownToggle, setTeamBreakdownToggle] = useState(Array(32).fill(true))
    const [teamFromDropdown, setTeamFromDropdown] = useState(undefined)
    
    useEffect(() => {
        getSession(setNewSession)
          .then((session) => {
            console.log('Session Activated');
          })
          .catch((err) => {
            console.log('Session: ', err);
          });
        
      }, []);

    function getAllPicks() {
        axios.get(`${API_BASE_URL}/picks-breakdown`, {
            headers: {
                Authorization: newSession['idToken']['jwtToken'],
                'Content-Type': 'application/json',
            },
            params: {year}
        }).then((response) => {
            console.log(response['data']['selectedPicks'])
            setSelectedPicksBreakdown(response['data']['selectedPicks']);
            setUnselectedPicksBreakdown(response['data']['unselectedPicks']);
        }).catch((error) => {
            console.log(error); 
            setShowCurrWeekAlertModal([true, 'Unable to get pick breakdown. Refresh the page and try again.', 'We\'ve hit a snag'])
        });
    }  

    useEffect(() => {
        if(newSession !== undefined) {
            getAllPicks();
        }
    },[newSession]);

    function updateBreakdownToggle(index, val) {
        let currBreakdownToggle = {...teamBreakdownToggle}
        currBreakdownToggle[index] = val
        setTeamBreakdownToggle(currBreakdownToggle)
    }


    let picksCards = []
    let teamToPickMap = {}
    const listedPicks = Object.keys(selectedPicksBreakdown)
    // for(const pick of Object.keys(selectedPicksBreakdown)) {
    for(let i = 0; i < listedPicks.length; i++ ) {
        const pick = listedPicks[i]
        var CurrTeam = teamIcons[pick];
        var pickedCaption = selectedPicksBreakdown[pick]?.length ? 'Picked (' + selectedPicksBreakdown[pick].length + ')' : 'Picked'
        var notPickedCaption = unselectedPicksBreakdown[pick]?.length ? 'Not Picked (' + unselectedPicksBreakdown[pick].length + ')' : 'Not Picked'
        picksCards.push(<Card className='pick-breakdown-card'>
            <Card.Header>
                <div className='pick-breakdown-card-header'>
                    <CurrTeam/>
                    <Nav variant="tabs" defaultActiveKey="#picked">
                        <Nav.Item>
                        <Nav.Link href="#picked" onClick={()=>{updateBreakdownToggle(i, true)}} className='pick-breakdown-card-nav-link'>{pickedCaption}</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                        <Nav.Link href="#link" onClick={()=>{updateBreakdownToggle(i, false)}} className='pick-breakdown-card-nav-link'>{notPickedCaption}</Nav.Link>
                        </Nav.Item>
                    </Nav>
                </div>
            </Card.Header>
            <Card.Body>
     
              <Card.Text>
                <ul className='pick-breakdown-card-text-ul'>
                    {
                        teamBreakdownToggle[i] ? 
                        selectedPicksBreakdown[pick].map((val) => {
                            return (<> <li>{val}</li></>)
                        }) :
                        unselectedPicksBreakdown[pick].map((val) => {
                            return (<> <li>{val}</li></>)
                        })
                    }
                </ul>
              </Card.Text>
            </Card.Body>
          </Card>)

        teamToPickMap[pick] = picksCards[i]
    }

    return (
        <>
            <div className='breakdown-page-header'>
                <h1 className='page-title'>Breakdown</h1>
                <p className='page-subtitle'>Picks by team for the current week</p>
            </div>
            <div className='breakdown-section-web'>
               <CardGroup className='pick-breakdown-card-group-web'>
                    {picksCards}
               </CardGroup>
            </div>   
            <div className='breakdown-section-mobile'>
                <DropdownButton id="dropdown-basic-button" title={teamFromDropdown ? teamFromDropdown : 'Select team'}>
                    {
                        teams.map((team) => {
                            return (
                                <Dropdown.Item onClick={()=> { setTeamFromDropdown(team)}}> { team } </Dropdown.Item>
                            )
                        })
                    }
                </DropdownButton>
                <CardGroup className='pick-breakdown-card-group-mobile'>
                    {teamToPickMap[teamFromDropdown]}
               </CardGroup>
            </div>
            <AlertModal
                    show={showCurrWeekAlertModal[0]}
                    onHide={()=>{setShowCurrWeekAlertModal([false, '', ''])}}
                    modalTitle={showCurrWeekAlertModal[2]}
                    modalBody={showCurrWeekAlertModal[1]}
            />   
        </>
    )
}

export default Breakdown;